import { render, staticRenderFns } from "./Jogos.vue?vue&type=template&id=496e9063"
import script from "./Jogos.vue?vue&type=script&lang=ts"
export * from "./Jogos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports